import * as React from 'react';
import { Dialog, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { hasBirthYear } from '@services/family/coppa';
import { buttonContained } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps {
  isOpen: boolean;
  child?: IFamilyMember;
  onClose: () => void;
}

/**
 * Shown in place of the invite dialog when a parent in the US tries to invite a child who
 * is not provably 13 yet. COPPA leaves no room to send the invitation, so the dialog only
 * explains the rule and says what happens instead - there is nothing here to confirm.
 *
 * A child with no year of birth on record is blocked as well, and gets its own wording:
 * telling that parent to wait until the child turns 13 would be a guess, since the child
 * may have been 13 for years already.
 */
const CoppaInviteBlockedDialog: React.FC<IProps> = ({isOpen, child, onClose}) => {
  const name = child ? child.firstName : tn.lang.coppaInviteBlockedTheChild;
  const explanation = hasBirthYear(child ? child.yearBorn : undefined)
    ? tn.lang.coppaInviteBlockedNextStep(name)
    : tn.lang.coppaInviteBlockedUnknownAge(name);

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{tn.lang.coppaInviteBlockedTitle}</DialogTitle>
      <DialogContent style={{display: 'flex', flexDirection: 'column', gap: '16px'}}>
        <Typography>{tn.lang.coppaInviteBlockedLaw}</Typography>
        <Typography>{explanation}</Typography>
      </DialogContent>
      <div style={{display: 'flex', justifyContent: 'flex-end', margin: '10px'}}>
        <Button variant='contained' style={buttonContained} color='primary' onClick={onClose}>
          {tn.lang.close}
        </Button>
      </div>
    </Dialog>
  );
};

export default CoppaInviteBlockedDialog;



// WEBPACK FOOTER //
// ./src/components/extended-family/CoppaInviteBlockedDialog.tsx